export const MAX_FAVOURITES_COUNT = 20
